import { Entity } from "../constants/entity";
import {
  BuildingIcon,
  Document1Icon,
  FuelIcon,
  HammerIcon,
  House3Icon,
  MapPin2Icon,
} from "@/shared/icons";
import { IconComponent } from "@/shared/icons/BaseIcon";

export const entityIcon: Record<Entity, { icon: IconComponent }> = {
  [Entity.House]: {
    icon: House3Icon,
  },
  [Entity.Business]: {
    icon: BuildingIcon,
  },
  [Entity.GasStation]: {
    icon: FuelIcon,
  },
  [Entity.Interior]: {
    icon: HammerIcon,
  },
  [Entity.InteriorList]: {
    icon: Document1Icon,
  },
  [Entity.Address]: {
    icon: MapPin2Icon,
  },
};
